import { FC, useEffect } from "react";
import {
  CheckAuthentication,
  HideBrokenImage,
  OpenImageInNewWindow,
  UpdateUserLastActionDate,
} from "../../../helper/ui/methods";
import { useNavigate } from "react-router-dom";
import { useAppStateContext } from "../../../middleware/context/state-context-provider";
import MainNavigationPanel from "../../ui/user/main-navigation-panel";
import MainFooterPanel from "../../ui/user/main-footer-panel";

export const Charvue: FC = () => {
  const [state, dispatch] = useAppStateContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (state.user === null || state.user === undefined) {
      CheckAuthentication(dispatch);
    }
  }, []);

  return (
    <>
      {(() => {
        return (
          <div
            id="pageWrapper"
            onClick={
              state.user
                ? () => UpdateUserLastActionDate(state.user!, dispatch)
                : undefined
            }
          >
            <MainNavigationPanel user={state.user} />
            <div id="contentWrapper">
              <div id="content" className="pageSurface">
                <div id="informationCanvas">
                  <div className="pageCrumbs">
                    <span
                      onClick={() => {
                        navigate("/products");
                      }}
                    >
                      PRODUCTS
                    </span>
                    <span>/</span>
                    <span className="crumbCurrent">CHARVUE</span>
                  </div>
                  <h1>Charvue</h1>
                  <p>
                    Charvue is part of ForgeLine, our Autodesk® Navisworks®
                    plugin. It enhances the functionality of the Navisworks
                    viewpoints export feature by offering four major
                    customizations.
                  </p>
                  <p>
                    First, the plugin records the location of each saved
                    viewpoint within the Navisworks "Saved Viewpoints" folder
                    structure. This feature is crucial for helping both the
                    report's authors and other users efficiently locate specific
                    viewpoints within Navisworks after the report is generated.
                  </p>
                  <p>
                    Second, it enables users to customize and adjust the
                    resolution of the exported images for each viewpoint. This
                    is particularly beneficial for detailed and complex
                    viewpoints.
                  </p>
                  <p>
                    Third, Charvue allows for flexible organization
                    of the final report by letting users choose the number of
                    rows and columns on each page. This optimization reduces the
                    overall number of pages and minimizes empty spaces, leading
                    to a more streamlined presentation.
                  </p>
                  <p>
                    Finally, the plugin offers the ability to distinguish
                    between saved viewpoints from different folders by altering
                    the background color of their respective containers in the
                    report. It also provides the option to exclude viewpoints
                    based on the folder name from the final report.
                  </p>
                  <p>
                    For detailed instructions on how to utilize Charvue
                    effectively, please consult the accompanying
                    <a
                      className="anchor"
                      href="https://digitalcharcoal.io/pdf/instructions/charvue/Charvue_Instruction.pdf"
                    >
                      {" "}
                      documentation
                    </a>
                    .
                  </p>
                  <div className="contentImageWrapper">
                    <img
                      src="assets/images/ncrp/ncrp_1.png"
                      alt="Charvue"
                      onClick={() =>
                        OpenImageInNewWindow("assets/images/ncrp/ncrp_1.png")
                      }
                      onError={HideBrokenImage}
                    />
                    <img
                      src="assets/images/ncrp/ncrp_2.png"
                      alt="Charvue"
                      onClick={() =>
                        OpenImageInNewWindow("assets/images/ncrp/ncrp_2.png")
                      }
                      onError={HideBrokenImage}
                    />
                    <img
                      src="assets/images/ncrp/ncrp_3.png"
                      alt="Charvue"
                      onClick={() =>
                        OpenImageInNewWindow("assets/images/ncrp/ncrp_3.png")
                      }
                      onError={HideBrokenImage}
                    />
                  </div>

                  <h3>Pricing</h3>
                  <p>
                    ForgeLine, with Charvue and Charsync, comes with every
                    Digital Charcoal seat: $50 a month or $500 a year, starting with a 30-day
                    trial.
                  </p>
                  <div className="pageActionWrapper">
                    <span
                      className="pageAction pageActionPrimary"
                      onClick={() => {
                        navigate("/pricing");
                      }}
                    >
                      See pricing
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <MainFooterPanel />
          </div>
        );
      })()}
    </>
  );
};
